import { render, staticRenderFns } from "./GestionTecnicalReportS2.vue?vue&type=template&id=fbe69b2a&"
import script from "./GestionTecnicalReportS2.vue?vue&type=script&lang=js&"
export * from "./GestionTecnicalReportS2.vue?vue&type=script&lang=js&"
import style0 from "./GestionTecnicalReportS2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports